/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Custom metadata values of the asset
 */
export type PublicGetCustomMetadataEntryDto = {
    /**
     * Name of the referenced custom metadata
     */
    customMetadataName: string;
    type: PublicGetCustomMetadataEntryDto.type;
};

export namespace PublicGetCustomMetadataEntryDto {

    export enum type {
        LABEL = 'LABEL',
        STRING = 'STRING',
        USER = 'USER',
        TEAM = 'TEAM',
    }


}
